/* ZETAW — File (HUD drawers) */
(function(){
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#/\\_-<>';
  var pad = function(n){ return String(n).padStart(2, '0'); };

  function init(root){
    if (!root || root._zf) return;
    root._zf = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var q = function(s){ return root.querySelector(s); };
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.zf-drw'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-zf-item]'));
    var drawers = q('.zf-drawers'), panel = q('[data-zf-panel]'), frame = q('.zf-frame');
    var prefix = (tabs[0] && tabs[0].querySelector('.zf-drw__code').textContent.split('-')[0]) || 'S';
    var idx = 0, busy = false, alive = true, glitch = 0;

    function scramble(el, text, ms){
      if (!el) return;
      if (reduce){ el.textContent = text; return; }
      var t0 = performance.now();
      (function f(now){
        var k = Math.min(1, (now - t0) / ms), n = Math.floor(text.length * k), out = '';
        for (var i = 0; i < text.length; i++){
          var ch = text[i];
          out += (i < n || ch === ' ') ? ch : GLYPHS[(Math.random() * GLYPHS.length) | 0];
        }
        el.textContent = out;
        if (k < 1) requestAnimationFrame(f);
      })(t0);
    }

    function mark(){
      tabs.forEach(function(b, i){
        var on = i === idx;
        b.setAttribute('aria-selected', on);
        b.tabIndex = on ? 0 : -1;
        var st = b.querySelector('.zf-drw__state'); if (st) st.textContent = on ? 'Open' : 'Locked';
      });
      if (frame && tabs[idx]) frame.setAttribute('aria-labelledby', tabs[idx].id);
    }

    function show(animate){
      items.forEach(function(it, i){ it.hidden = i !== idx; });
      var it = items[idx]; if (!it) return;
      var idEl = q('[data-zf-id]'), clEl = q('[data-zf-clear]'), gh = q('[data-zf-ghost]'), ct = q('[data-zf-count]');
      if (idEl) idEl.textContent = prefix + '-' + pad(idx + 1);
      if (clEl) clEl.textContent = it.getAttribute('data-clear') || '';
      if (gh) gh.textContent = pad(idx + 1);
      if (ct) ct.textContent = pad(idx + 1) + ' / ' + pad(items.length);
      var ps = it.querySelectorAll('.zf-body p');
      Array.prototype.forEach.call(ps, function(p, i){ p.style.animationDelay = (0.42 + i * 0.16) + 's'; });
      Array.prototype.forEach.call(it.querySelectorAll('.zf-spec'), function(s, i){ s.style.animationDelay = (0.6 + i * 0.08) + 's'; });
      var late = 0.55 + ps.length * 0.16;
      Array.prototype.forEach.call(it.querySelectorAll('.zf-shot, .zf-cta'), function(s){ s.style.animationDelay = late + 's'; });
      if (animate){
        var t = it.querySelector('[data-zf-title]');
        if (t){ if (!t._txt) t._txt = t.textContent; scramble(t, t._txt, 520); }
        scramble(q('[data-zf-status]'), 'Decrypted', 700);
        Array.prototype.forEach.call(it.querySelectorAll('.zf-spec dd'), function(dd){ if (!dd._txt) dd._txt = dd.textContent; scramble(dd, dd._txt, 900); });
      }
    }

    function open(i, focus){
      if (busy || i === idx){ if (focus && tabs[i]) tabs[i].focus(); return; }
      idx = i; mark();
      if (focus && tabs[i]) tabs[i].focus();
      if (tabs[i] && tabs[i].scrollIntoView && window.innerWidth <= 860) tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      if (reduce){ show(false); return; }
      busy = true; drawers.classList.add('is-busy'); glitch = 1;
      var st = q('[data-zf-status]'); if (st) st.textContent = 'Loading';
      panel.classList.remove('is-opening');
      panel.classList.add('is-closing');
      setTimeout(function(){
        show(true);
        panel.classList.remove('is-closing');
        void panel.offsetWidth;
        panel.classList.add('is-opening');
        setTimeout(function(){ busy = false; drawers.classList.remove('is-busy'); }, 700);
        setTimeout(function(){ panel.classList.remove('is-opening'); }, 1600);
      }, 230);
    }

    tabs.forEach(function(b, i){
      b.addEventListener('click', function(){ open(i); });
      b.addEventListener('keydown', function(e){
        var n = tabs.length, k = e.key;
        if (k === 'ArrowDown' || k === 'ArrowRight'){ e.preventDefault(); open((idx + 1) % n, true); }
        if (k === 'ArrowUp' || k === 'ArrowLeft'){ e.preventDefault(); open((idx - 1 + n) % n, true); }
      });
    });
    var prev = q('[data-zf-prev]'), next = q('[data-zf-next]');
    if (prev) prev.addEventListener('click', function(){ open((idx - 1 + tabs.length) % tabs.length); });
    if (next) next.addEventListener('click', function(){ open((idx + 1) % tabs.length); });
    root._zfOpen = function(i){ busy = false; open(i); };
    show(false);

    /* clock */
    var clock = q('[data-zf-clock]'), timer;
    if (clock){
      var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
      var tick = function(){ clock.textContent = fmt.format(new Date()); };
      tick(); timer = setInterval(tick, 1000);
    }

    /* signal box + background arcs */
    var sc = q('.zf-sig canvas'), sx = sc && sc.getContext('2d');
    var bg = q('.zf-bg'), bx = bg && bg.getContext('2d');
    var dpr = Math.min(2, window.devicePixelRatio || 1), visible = true;
    function size(){ if (!bg) return; bg.width = root.clientWidth * dpr; bg.height = root.clientHeight * dpr; }
    size();
    var ro = window.ResizeObserver ? new ResizeObserver(size) : null; if (ro) ro.observe(root);
    if ('IntersectionObserver' in window) new IntersectionObserver(function(e){ visible = e[0].isIntersecting; }).observe(root);

    function drawSig(t){
      if (!sx) return;
      var W = sc.width, H = sc.height;
      sx.fillStyle = '#000'; sx.fillRect(0, 0, W, H);
      sx.strokeStyle = 'rgba(240,236,227,.12)'; sx.lineWidth = 1;
      for (var gx = 0; gx < W; gx += 30){ sx.beginPath(); sx.moveTo(gx, 0); sx.lineTo(gx, H); sx.stroke(); }
      sx.strokeStyle = glitch > .05 ? '#ffffff' : 'rgba(240,236,227,.85)'; sx.lineWidth = 2;
      sx.beginPath();
      for (var x = 0; x <= W; x += 3){
        var y = H / 2 + Math.sin(x * .05 + t * .004) * 18 * Math.sin(t * .0009 + idx) + Math.sin(x * .21 + t * .011) * 6 + (Math.random() - .5) * (4 + glitch * 60);
        x ? sx.lineTo(x, y) : sx.moveTo(x, y);
      }
      sx.stroke();
      if (glitch > .05){ for (var k = 0; k < 4; k++){ var yy = Math.random() * H; sx.drawImage(sc, 0, yy, W, 8, (Math.random() - .5) * 30, yy, W, 8); } }
      glitch *= .9;
    }
    function drawBg(t){
      if (!bx) return;
      var W = bg.width, H = bg.height;
      bx.clearRect(0, 0, W, H);
      var cx = W * .86, cy = Math.min(H * .18, 300 * dpr), R = Math.max(W, 900 * dpr) * .42;
      for (var r = 0; r < 3; r++){
        var rad = R * (.7 + r * .16), segs = 48, rot = t * .00004 * (r % 2 ? -1 : 1) * (1 + r * .4);
        for (var s = 0; s < segs; s++){
          var a0 = rot + s / segs * Math.PI * 2, a1 = a0 + Math.PI * 2 / segs * .6;
          var v = .5 + .5 * Math.sin(a0 * 3 - t * .0006 + r);
          if (v < .35) continue;
          bx.strokeStyle = 'rgba(240,236,227,' + (v * .08).toFixed(3) + ')';
          bx.lineWidth = (r === 1 ? 2 : 1) * dpr;
          bx.beginPath(); bx.arc(cx, cy, rad, a0, a1); bx.stroke();
        }
      }
    }
    function loop(t){
      if (!alive) return;
      requestAnimationFrame(loop);
      if (!visible) return;
      drawSig(t);
      if (!reduce || !loop.done){ drawBg(t); loop.done = true; }
    }
    requestAnimationFrame(loop);

    root._zfDestroy = function(){ alive = false; clearInterval(timer); if (ro) ro.disconnect(); };
  }

  function boot(scope){ Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zetaw-file]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); }); else boot();

  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  document.addEventListener('shopify:section:unload', function(e){
    var r = e.target.querySelector('[data-zetaw-file]'); if (r && r._zfDestroy) r._zfDestroy();
  });
  document.addEventListener('shopify:block:select', function(e){
    var r = e.target.closest && e.target.closest('[data-zetaw-file]');
    if (!r || !r._zfOpen) return;
    var tabs = Array.prototype.slice.call(r.querySelectorAll('.zf-drw'));
    var i = tabs.indexOf(e.target); if (i > -1) r._zfOpen(i);
  });
})();
